import React from 'react'
import DateTimeField from 'react-bootstrap-datetimepicker'

class DatePicker extends React.Component {
  static propTypes = {
    placeholder: React.PropTypes.string,
    onChange: React.PropTypes.func,
    valueLink: React.PropTypes.object,
    value: React.PropTypes.string,
    label: React.PropTypes.string
  }

  onChange (date, inputEntry) {
    if (date === 'Invalid date') date = undefined

    if (date || (!date && !inputEntry)) {
      // Dispatch to caller onChange if present
      if (this.props.onChange) {
        this.props.onChange(date)
      }

      if (this.props.valueLink) {
        // Single select: send text value to valueLink
        this.props.valueLink.requestChange(date)
      }
    }
  }

  render() {
    const { valueLink, placeholder, ...other } = this.props
    let { value } = this.props

    value = value || valueLink.value
    if (value && value.toJS) value = value.toJS()

    other.defaultText = placeholder || 'Select a date'

    return (
      <DateTimeField
        mode="date"
        inputFormat="MM/DD/YYYY"
        format="YYYY-MM-DD"
        dateTime={value}
        onChange={::this.onChange}
        {...other}
      />
    )
  }
}

export default DatePicker



// WEBPACK FOOTER //
// ./modules/shared/components/datePicker.js